import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default class UpdateOperatorDialogCount extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "updateOperatorDialogCount";
    }

    public receive(payload: CometOperatorApplication.UpdateOperatorDialogCountCometMessageOpenApiModel): void {
        OperatorAccountStore.SET_OPERATOR_DIALOG_COUNT(payload);
    }

}